export default __webpack_public_path__ + "static/media/README.e2ebbf3a.md";